import React, { useState } from 'react';
import { BoxWrapper, ButtonExpand } from 'components/Base';

interface FilterOptionWrapperProps {
  label: string;
  children?: React.ReactNode; // This will allow children to be passed in
  open?: boolean;
}

const FilterOptionWrapper = ({
  label,
  children,
  open = false
}: FilterOptionWrapperProps) => {
  const [isOpen, setIsOpen] = useState(open);
  return (
    <BoxWrapper
      title={label}
      wrap
      headerChildren={
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '1rem'
          }}
        >
          <ButtonExpand
            variant="contained"
            color="secondary"
            style={{
              backgroundColor: '#0080BD',
              height: '42px',
              marginRight: 'auto'
            }}
            isOpen={isOpen}
            onClick={() => setIsOpen(!isOpen)}
          >
            View
          </ButtonExpand>
        </div>
      }
    >
      <div
        style={{
          padding: '1rem 1rem 1.5rem',
          flexDirection: 'column',
          gap: '1rem',
          display: isOpen ? 'flex' : 'none'
        }}
      >
        {children}
      </div>
    </BoxWrapper>
  );
};

export default FilterOptionWrapper;
